module.exports = ".employerSelect {\n  width: 100%; }\n\n.warn {\n  font-weight: bold;\n  color: #9A0000; }\n\n.projectSelect {\n  margin-top: 0.5em;\n  margin-right: 0.5em; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/accounts/createaccount.component.scss
// module id = 343
// module chunks = 1